/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";

class ExaminationProperties extends BaseCom {
    render() {
        return <div className="ExaminationProperties">
            {this.props.item.physical && this.props.item.physical.length !== 0 ? <Card title="Physical">
                {this.props.item.physical.map(i => <div>
                    <h4>{i.name}</h4>
                    <p>{i.value}</p>
                </div>)}
            </Card> : ''}
        </div>;
    }
}

export default ExaminationProperties;